import { Typography } from "@material-tailwind/react";
import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';
import UploadImage from '../assets/images/Frame 1618870273.png';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {  EditCategories } from '../services/addCategoryServices';
import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import { fetchFoodCategories } from "../redux/slices/categoriesSlice";
import { useDispatch } from "react-redux";
import { FaTimesCircle } from "react-icons/fa";
import ButtonLoader from "../components/ButtonLoader";


const EditFoodCategory = ({ isOpen, onClose, item}) => {
  const dispatch = useDispatch();
  const [imageFile, setImageFile] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() =>{
    dispatch(fetchFoodCategories())
  }, [dispatch]);

  useEffect(() => {
    if (item?.foodImages?.length > 0) {
      setImageFile(item.foodImages[0].fileUrl);
    }
  }, [item]);

  const formik = useFormik({
    initialValues: {
      name: '',
      imagePath: '',
      id: item?.categoryId,
    },
    validationSchema: Yup.object({
      id: Yup.string(),
      name: Yup.string(),
      imagePath: Yup.string().required('Image path is required'),
    }),
    
    onSubmit: async (values) => {
      setLoading(true);
      const res = await EditCategories(values);
      if(res.statusCode === 200){
        toast.success(res?.message)
        dispatch(fetchFoodCategories())
        setLoading(false)
        onClose(false)
      } else if(res?.statusCode === 203){
        toast.error(res.message)
        setLoading(false)
      } else if(res?.statusCode === 404){
        toast.error(res.message)
        setLoading(false)
      } else if(res?.statusCode === 999){
        toast.error(res.message)
        setLoading(false)
       } else {
        console.log(res?.message)
      }
    },
  });

  useEffect(() => {
    if(item){
      formik.setFieldValue("id", item?.categoryId);
      formik.setFieldValue("name", item?.categoryName);
      if(item?.foodImages?.length > 0){
        formik.setFieldValue("imagePath", item?.foodImages[0].fileUrl);
      }
    }
  },[item]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setImageFile(base64String); 
        formik.setFieldValue("imagePath", base64String); 
      };
      reader.readAsDataURL(file);
    }
  };

  const deleteImage = () => {
    setImageFile(null);
    formik.setFieldValue("imagePath", ""); 
  };
  

  return (
    <div>
      <Drawer anchor="right" open={isOpen} onClose={onClose} size="md"
         slotProps={{
          root: {
            className: `
              backdrop-blur-[1px] 
              bg-orange/20 
              rounded-tl-2xl 
            `,
          },
        }}  
      >
        <ModalClose />
          <div className="flex items-center justify-between gap-4 px-5 pt-10">
            <Typography className="capitalize text-[24px] font-bold text-primaryRed">Edit Food Category</Typography>
          </div>
          <Typography className="mb-6 mt-4 text-xs px-5 text-[#0A0A0ACC]">
            Add a fresh category to expand your menu and give customers more tasty options!          
          </Typography>

          <form onSubmit={formik.handleSubmit} className="mt-3 text-xs space-y-4 p-5">
              <label htmlFor="name">Menu Name</label>
              <div className="my-2">
                <input
                  id="name"
                  name="name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  defaultValue={formik.values.name}
                  className="border border-[#00000] border-opacity-30 text-black rounded-md px-4 w-full py-1.5 outline-none ring-0 focus:outline-0 "
                  placeholder="E.G Street Food, Dessert, Brevegaes"
                 />
                {formik.touched.name && formik.errors.name ? (
                  <div>{formik.errors.name}</div>
                ) : null}
              </div>
                {/* <div>
                  <label htmlFor="description">Description</label>
                  <input 
                    id="description"
                    name="description"
                    type="text"
                    placeholder="Describe____ this category, e.g., 'Classic Nigerian street snacks and quick bites." 
                    className="border border-[#00000] border-opacity-30 px-3 rounded-md w-full py-1.5 placeholder:text-gray-400 text-sm outline-none ring-0 focus:outline-0"
                  />
                </div> */}
            <h2 className="text-sm mt-2">Add Image</h2>
            <p className="text-xs">Upload a clear  500x500 pixels, for the best display.</p>
            <div className="grid place-items-center mt-8">
              {imageFile ? (
                <div className="relative">
                  <img src={imageFile} alt="Selected" className="w-full h-full object-cover mb-4" />
                  <button
                    className="absolute top-2 right-2 outline-0 duration-500 transition-all ease-in-out"
                    onClick={deleteImage}
                  >
                    <FaTimesCircle className="text-3xl font-bold text-primaryRed" />
                  </button>
                </div>
              ) : (
                <>
                  <label className="cursor-pointer border rounded-lg rounded-tr-2xl">
                    <img src={UploadImage} alt="Placeholder" />
                    <input
                      type="file"
                      id="imagePath"
                      name="imagePath"
                      accept="image/*"
                      onChange={handleFileChange}
                      className="hidden"
                    />
                    {formik.touched.imagePath && formik.errors.imagePath ? (
                      <div className="text-red-500 text-xs">{formik.errors.imagePath}</div>
                    ) : null}
                  </label>
                </>
              )}
            </div>
            <div className="flex items-center gap-10 justify-between">
              <button
              onClick={onClose}
                className="text-primaryRed hover:bg-opacity-50 bg-white w-full px-4 py-2 rounded-md outline-none ring-0 border border-primaryRed hover:bg-primaryRed hover:text-white text-md hover:outline-none capitalize mt-6 focus:outline-none focus:border-primaryRed hover:border-primaryRed"
              >Cancel </button>
              <button
                type="submit"
                disabled={loading}
                className="bg-[#FF0000] hover:bg-primaryRed/50 text-white text-md w-full px-4 py-2 rounded-md outline-none ring-0 border border-primaryRed hover:text-white capitalize mt-6 focus:outline-none focus:border-primaryRed hover:border-PrimaryRed"
                > {loading ? <ButtonLoader />
                  : <p>Save</p>
                }
              </button>
            </div>
          </form>
      </Drawer>
    </div>
  );
}

export default EditFoodCategory
